<template>
<Navbar v-if="this.lang == 'id'"></Navbar>
<NavbarEn v-else-if="this.lang == 'en'"></NavbarEn>
	
    <div class="contact">
		<div class="header-p">
			<div class="container">
				<div v-if="this.lang == 'en'">
					<h1>Any Question To Us?</h1>
					<hr>
					<h5>We Are Here To Help</h5>
				</div>
				<div v-else-if="this.lang == 'id'">
					<h1>Ada Pertanyaan Untuk Kami?</h1>
					<hr>
					<h5>Kami Disini Untuk Membantu</h5>
				</div>
			</div>
		</div>
		<div class="inform">
			<div class="container">
				<div class="row">
					<div class="col-lg-7 col-md-12">
						<div v-if="this.lang == 'en'">
							<h3>Contact Us</h3>
						</div>
						<div v-else-if="this.lang == 'id'">
							<h3>Hubungi Kami</h3>
						</div>
						
						<hr>

						<div v-if="sukses" class="alert alert-success" role="alert">
							<strong>Berhasil!</strong> Pesan anda telah terkirim.
						</div>
						<form @submit.prevent="store()">
							<div class="mb-3">
								<label for="name" class="form-label"><span>Name</span></label>
								<input type="text" class="form-control" id="name" v-model="hubKami.nama" required>
								
							</div>
							<div class="mb-3">
								<label for="email" class="form-label"><span>Email</span></label>
								<input type="email" class="form-control" id="email" v-model="hubKami.email" required>
							</div>
							<div class="mb-3">
								<label for="hp" class="form-label"><span>No. Telepon</span></label>
								<input type="number" class="form-control" id="hp" v-model="hubKami.phone_number" required>
								
							</div>
							<div class="mb-3">
								<label for="subject" class="form-label"><span>Subject</span></label>
								<input type="text" class="form-control" id="subject" v-model="hubKami.subject" required>
								
							</div>
							<div class="mb-3">
								<label for="pesan" class="form-label"><span>Message</span></label>
								<textarea class="form-control" id="pesan" rows="4" v-model="hubKami.message" required></textarea>
							</div>
							<div class="d-grid gap-2 col-4">
								<button type="submit" class="btn btn__primary d-flex align-items-center justify-content-center" :disabled="loading">
									<div v-if="loading" class="spinner-border text-light me-2" :disabled="loading"></div>
									<span v-if="!loading">
										<div v-if="this.lang == 'en'">
											Send
										</div>
										<div v-else-if="this.lang == 'id'">
											Kirim
										</div>
									</span>
								</button>
								
							</div>
						</form>
					</div>

					<div class="col-lg-5 col-md-12">
						<h3 v-if="this.lang == 'en'">Our Information</h3>
						<h3 v-else-if="this.lang == 'id'">Informasi Kami</h3>
						<hr>

						<ul class="list-group">
							<li class="list-group-item d-flex justify-content-start align-items-top">
								<span class="badge">
									<img src="../assets/icon/map.svg" alt="">
								</span>
								{{contact.address}}
							</li>
							<li class="list-group-item d-flex justify-content-start align-items-top">
								<span class="badge">
									<img src="../assets/icon/phone.svg" alt="">
								</span>
								{{contact.phone_number}} <br>
								{{contact.second_phone_number}}
							</li>
							<li class="list-group-item d-flex justify-content-start align-items-center">
								<span class="badge">
									<img src="../assets/icon/envelove.svg" alt="">
								</span>
								<div class="email">
									<a href="mailto:gamamanagement@gmail.com">{{contact.first_email}}</a> <br>
									<a href="mailto:gamasertifikasi@gmail.com">{{contact.second_email}}</a>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="maps">
				<iframe 
					width="600" 
					height="450" 
					frameborder="0" 
					scrolling="no" 
					marginheight="0" 
					marginwidth="0" 
					:src="'https://maps.google.com/maps?q='+contact.latitude+','+contact.longitude+'&hl=es&z=14&amp;output=embed'"
				>
				</iframe>
			</div>
		</div>
		<div class="langApp">
			<div class="btn-group dropstart">
				<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
						<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#0054a5"/>
					</svg>
				</button>
				<ul class="dropdown-menu">
					<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
					<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

				</ul>
			</div>
		</div>
    </div>
    <Footer />
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue'
import Navbar from '@/components/Navbar.vue'
import NavbarEn from '@/components/NavbarEn.vue'
import { reactive, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

export default {
    name: 'About',
    components: {
        Footer,
		Navbar,
		NavbarEn
    },
	data() {
        return {
            activeLanguage: this.lang
        }
    },
	methods: {
        selectLanguage: function (lang) {
            this.activeLanguage = lang;
            this.lang = lang;
            
            localStorage.setItem("lang", lang);
        }
    },
	setup() {
		const hubKami = reactive ({
			nama: '',
			email: '',
			phone_number: '',
			subject: '',
			message: '',
		});

		const sukses = ref(false);
		const loading = ref(false);

		const validation = ref([]);
		const contact = ref([]);

		const router = useRouter();

		onMounted(() => {
			axios.get('setting')
			.then((result) => {
				console.log(result)
				contact.value = result.data
			}).catch((err) => {
				console.log(err.response)
			})
		})

		function store() {
			axios.post(
				'HubungiKami',
				hubKami
			)
			.then(() => {
				loading.value = true
				setTimeout(() => {
					loading.value = false
				}, 1000)

				this.hubKami.nama = ''
				this.hubKami.email = ''
				this.hubKami.phone_number = ''
				this.hubKami.subject = ''
				this.hubKami.message = ''

				sukses.value = true
				setTimeout(() => {
					sukses.value = false
				}, 4000)

				// router.push({
				// 	path: '/contact'
				// });
				// alert('Pesan Anda Berhasil Terkirim'),
				// location.reload()
			}).catch((err) => {
				validation.value = err.response.data
			});
		}

		return {
			hubKami,
			validation,
			router,
			store,
			sukses,
			loading,
			contact
		}
	},
}
</script>

<style>

.contact .header-p h5{
	color: white;
	font-weight: 600;
	text-transform: capitalize;
	text-align: center;
	padding-top: 20px;
}
.contact .inform{
	padding: 50px 0;
}
.contact .inform h3{
	color: var(--dark-grey-);
	font-weight: 600;
}
.contact .inform hr{
	background: var(--secondary-);
	width: 80px;
	height: 3px;
	opacity: 1;
	margin-bottom: 30px;
}

.contact .inform ul.list-group li{
	border: none;
	color: var(--dark-grey-);
}
.contact .inform ul.list-group li a{
	color: var(--dark-grey-);
	text-decoration: none;
}
.contact .inform ul.list-group li a:hover{
	color: var(--secondary-);
	text-decoration: underline;
}

.contact .inform form label{
	font-size: 10pt;
	margin-left: 10px;
	position: relative;
	z-index: 6;
}
.contact .inform form .validation{
	font-size: 10pt;
}
.contact .inform form label span{
	background: white;
	padding: 0 10px;
}
.contact .inform form input{
	border-radius: 10px;
	padding: 10px;
	margin-top: -18px;
}
.contact .inform form input:focus{
	box-shadow: none;
	border: 1px solid var(--primary-);
}
.contact .inform form textarea{
	border-radius: 10px;
	padding: 10px;
	margin-top: -18px;
}
.contact .inform form textarea:focus{
	box-shadow: none;
	border: 1px solid var(--primary-);
}
.contact .inform form button{
	margin-bottom: 30px;
}


.contact .inform .maps iframe{
	width: 100%;
	height: 350px;
	margin-bottom: -80px;
	margin-top: 50px;
}
@media (max-width: 768px)
{
	
}
</style>